/* 🤖 this file was generated by svg-to-ts */
export const matIconReorder: {
  name: 'reorder';
  data: string;
} = {
  name: 'reorder',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"/></svg>`
};
